import React, { FunctionComponent } from 'react';
import { SxProps, Theme } from '@mui/material';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import { AStatusActionCard } from '@atiautomacao/ati-ui-library';
import { MenuItemStatus } from '../../../../../../Shared/Components/Layout/menu/types/MenuItemStatus';
import { DateFormat } from '../../../../../../Utils/DateFormatPatternUtils';
import { buildColorTintSx } from '../cardColorTint';
import {
    COMMUNICATION_CARD_CONTENT,
    CommunicationCardState,
    resolveCommunicationCardState,
} from './communicationCardState';

export interface InverterCommunicationCardProps {
    status?: MenuItemStatus;
    lastDateTime?: string;
}

const ICON_BY_STATE: Record<CommunicationCardState, React.ReactNode> = {
    COMMUNICATING: <WifiOutlinedIcon />,
    NO_COMMUNICATION: <WifiOffOutlinedIcon />,
    SYNCHRONIZING: <SyncOutlinedIcon />,
};

// "Sem comunicação" usa o laranja do sistema (status "Sem Comunicação" = #ff7800 na tabela `status`),
// não o vermelho — no sistema o vermelho é reservado a alarme. O AStatusActionCard não tem tom
// laranja, então tingimos via sx theme-aware (claro no tema claro, escuro no tema escuro).
const NO_COMMUNICATION_COLOR = 'ff7800';

/**
 * Card de comunicação da tela simplificada de inversor.
 *
 * Container do `AStatusActionCard` da ati-ui-library: resolve o estado de comunicação a partir do
 * `etsStatus` e exibe a última atualização (mesma origem já usada hoje). A apresentação — faixa com
 * ícone e textos — vem da biblioteca.
 */
const InverterCommunicationCard: FunctionComponent<InverterCommunicationCardProps> = ({ status, lastDateTime }) => {
    const state = resolveCommunicationCardState(status);
    const content = COMMUNICATION_CARD_CONTENT[state];
    const formattedDate = lastDateTime ? DateFormat(lastDateTime) : '-';

    const sx: SxProps<Theme> = [
        { height: '100%' },
        ...(state === 'NO_COMMUNICATION' ? [buildColorTintSx(NO_COMMUNICATION_COLOR)] : []),
    ];

    return (
        <AStatusActionCard
            ariaLabel="inverter-simple-communication"
            icon={ICON_BY_STATE[state]}
            subText={`Última atualização: ${formattedDate}`}
            sx={sx}
            text={content.text}
            tone={content.tone}
        />
    );
};

export default InverterCommunicationCard;
